/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Kind_Horse_LeapInputs */

const en_fresh_kind_horse_leap = /** @type {(inputs: Fresh_Kind_Horse_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should be imported?`)
};

const de_fresh_kind_horse_leap = /** @type {(inputs: Fresh_Kind_Horse_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was soll importiert werden?`)
};

/**
* | output |
* | --- |
* | "What should be imported?" |
*
* @param {Fresh_Kind_Horse_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_kind_horse_leap = /** @type {((inputs?: Fresh_Kind_Horse_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Kind_Horse_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_kind_horse_leap(inputs)
	return de_fresh_kind_horse_leap(inputs)
});